module.exports = __webpack_public_path__ + "static/media/expand_your_network.3ab8c48b.jpeg";